export const Elektrihind = "elektrihind.ee";
export const Gaasihind = "gaasihind.ee";
export const Coop = "coop";
export const Cashbackworld = "cashbackworld";
export const Alexela = "alexela.ee";
export const AlexelaLv = "alexela.lv";
export const PinkElephant = "roosaelevant";
export const SpringCampaign = "sugis2021kampaania";
export const TalTech = "taltech";